export const optionsPopover = [
  {
    name: 'Selected',
    iconPath: null,
    option: 1
  },
  {
    name: 'Rename',
    iconPath: 'edit',
    option: 2,
    height: 18
  },
  {
    name: 'Share',
    iconPath: 'share',
    option: 5,
    height: 16.5
  },
  {
    name: 'Delete',
    iconPath: 'remove',
    option: 3,
    height: 23.5
  },
  {
    name: 'Cancel',
    iconPath: 'cancel-selection',
    option: 4,
    height: 20
  }
];

export const baseurl = 'https://v6itjoj11g.execute-api.us-west-2.amazonaws.com';
